import { z } from "zod";
import { schemes } from "@zeal/common";

export const getOrderStatisticsRequestSchema = z.object({
  companyID: schemes.companyID(),
});

export const getOrderStatisticsResponseSchema = z.object({
  available_balance: z.number(),
  order_count: z.number(),
});

export type TGetOrderStatisticsRequest = z.infer<
  typeof getOrderStatisticsRequestSchema
>;
export type TGetOrderStatisticsResponse = z.infer<
  typeof getOrderStatisticsResponseSchema
>;
